<template xmlns="http://www.w3.org/1999/html">
    <div>
        <section class="internal-page-banner-main col-xs-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1>Add Image For Gallery</h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="internal-page-main-section col-xs-12">
            <div class="container">
                <div class="row">
                    <div class="survey-main-section col-xs-12 float-l">
                        <div class="">
                            <div class="">
                                <form id="categorieForm" method="POST" enctype="multipart/form-data">
                                    <!--<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="mediaSource">Image Source</label>
                                            <div class="form-line">
                                                <input type="text" id="mediaSource" name="mediaSource" class="form-control"
                                                       placeholder="Enter Image Source" v-model="mediaSource">
                                            </div>
                                        </div>
                                    </div>-->
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label for="mediaCaption">Image Caption</label>
                                            <div class="form-line">
                                                <input maxlength="190" type="text" id="mediaCaption" name="mediaCaption" class="form-control"
                                                       placeholder="Enter Image Caption" v-model="mediaCaption">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <template>
                                            <div id="app">
                                                <vue-dropzone
                                                    id="drop1"
                                                    :options="dropzoneOptions"
                                                    ref="dropzone"
                                                    :destroyDropzone="false"
                                                    :headers="dropzoneOptions.headers"
                                                    @vdropzone-removed-file="removedSelectedFile"
                                                    @vdropzone-success="vfileSuccess"
                                                    @vdropzone-duplicate-file="vduplicateFile"
                                                    @vdropzone-total-upload-progress="progressOfUload"
                                                    name="file"
                                                    >
                                                </vue-dropzone>
                                                <font class="text-danger">{{cropError}}</font>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="clearfix"></div>
                                    <br/>
                                </form>
                                <div class="clearfix" >
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="alert" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <strong id="errorMsg" class="error"></strong>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="saveMediaDetail()"></input>
                                        <button id="removeAll" class="btn btn-primary" @click="removeAllFiles">Clear Image</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import TEST from "./backend/policiesandforms/test";
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    var self;
    export default {
        name: 'AddPhoto',
        mixins: [SessioMixin],
        components: {
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                mediaSource: "",
                mediaCaption: "",
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "Image is to big ({{filesize}}mb). Max allowed image size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid Image Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 image is allowed",
                    dictDefaultMessage: "Drop image here to upload",
                },
                question: '',
                answer: '',
                questionList: [],
                accordinndId: 0,
                firstload: true,
                cropError: '',
                imagesType: [],
                imagesSize: [],
                imagesPaths: [],
                mediaThumbnailPaths: [],
                isFileUploaded: false,
            }
        },
        computed: {
        },
        watch: {

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.MenuClose();
            self.getPermissions();
            self.getBuildVersion();
            $("#alertError").hide();
            $("#addMedia, #removeAll").prop('disabled', true);
        },

        methods: {
            promptMessage: function (messagge, type) {
                if (typeof type === "undefined" || type === null) {
                    type = "success";
                }
                var AddClass = (type == "success") ? "alert-success" : "alert-danger";
                var RemoveClass = (type == "success") ? "alert-danger" : "alert-success";
                $("#alertError").show();
                $("#alertError").removeClass(RemoveClass);
                $("#alertError").addClass(AddClass);
                $("." + AddClass).removeClass("hide");
                $("." + AddClass).addClass("show");
                $("#errorMsg").html(messagge);
                setTimeout(function () {
                    $("." + AddClass).removeClass("show");
                    $("." + AddClass).addClass("hide");
                }, 5000);
            },
            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
                $("#addMedia, #removeAll").prop('disabled', true);
            },
            removedSelectedFile(file, xhr, error) {
                if (self.imagesPaths.length <= 0) {
                    self.isFileUploaded = false;
                    $("#addMedia, #removeAll").prop('disabled', true);
                }
                if (typeof (file.xhr) != "undefined") {
                    var filePath = JSON.parse(file.xhr.response);
                    //console.log(file);
                    if ("media_thumb_path" in filePath.content) {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                    } else {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, "");
                    }
                    for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                        if (self.imagesPaths[i] === filePath.content.media_path) {
                            self.imagesPaths.splice(i, 1);
                            self.imagesType.splice(i, 1);
                            self.imagesSize.splice(i, 1);
                            self.mediaThumbnailPaths.splice(i, 1);
                            // break;       //<-- Uncomment  if only the first term has to be removed
                        }
                    }
                }
            },
            vfilesAdded: function (file) {
                for (var i = 0; i < file.length; i++) {
                    var indiFile = file[i];
                    var fileSize = indiFile.size / (1024 * 1024);
                    /*return false;*/
                    if (indiFile.type == 'image/jpeg' || indiFile.type == 'image/jpg' || indiFile.type == 'image/png') {
                        if (fileSize > 0.1) { // Allowing image upto 4 MB to be uploaded
                            alert("Please select media upto 4 MB of size.");
                            self.$refs.dropzone.removeFile(indiFile);
                        }
                    }
                }
            },
            vfileSuccess: function (file, response) {
                self.isFileUploaded = true;
                self.imagesPaths.push(response.content.media_path);
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths.push(response.content.media_thumb_path);
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.imagesType.push(file.type);
                self.imagesSize.push(file.size);
                if (self.imagesPaths.length > 0) {
                    self.cropError = "";
                } else {
                    self.cropError = 'Please Upload Images';
                }
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },

            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    $("#addMedia, #removeAll").prop('disabled', false);
                    /*console.log(totaluploadprogress);
                     console.log(totalBytes);
                     console.log(totalBytesSent);*/
                } else {
                    $("#addMedia, #removeAll").prop('disabled', true);
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            checkForm: function () {
                var checked = true;
                self.cropError = "";

                if (self.isFileUploaded == false) {
                    self.cropError = 'Please Upload Images';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.imagesPaths.length > 0) {
                    self.cropError = "";
                } else {
                    self.cropError = 'Please Upload Images';
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },
            saveMediaDetail: function () {
                if (self.checkForm()) {
                    if (self.imagesPaths.length > 0) {
                        $("#addMedia, #removeAll").prop('disabled', true);
                        var fields = {
                            mediaSource: self.mediaSource,
                            mediaCaption: self.mediaCaption,
                            mediaPath: self.imagesPaths,
                            mediaThumbnailPaths: self.mediaThumbnailPaths,
                            mediaType: self.imagesType,
                            mediaSize: self.imagesSize,
                        };
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                        };
                        HTTP.post("uploadgalleryimage", fields, config)
                                .then(function (response) {
                                    self.removeAllFiles();
                                    self.mediaSource = "";
                                    self.mediaCaption = "";
                                    self.imagesPaths = [];
                                    self.mediaThumbnailPaths = [];
                                    self.imagesType = [];
                                    self.imagesSize = [];
                                    self.promptMessage(response.data.message, 'success');
                                    $("#addMedia, #removeAll").prop('disabled', false);
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                    $("#addMedia, #removeAll").prop('disabled', false);
                                });
                    } else {
                        self.cropError = 'Please Upload Images';
                    }
                }

            },
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/AddPhoto.vue